import LegalPageLayout, { Sec, List } from "@/components/legal/LegalPageLayout";
import { LEGAL_DOCUMENTS } from "@/lib/legalDocuments";

export default function ESignConsent() {
  return (
    <LegalPageLayout
      document={LEGAL_DOCUMENTS.esign}
      seoDescription="Electronic Signature and Electronic Records Consent for Hannah Howard Funding."
    >
      <Sec n="1" title="Purpose">
        <p>This Electronic Signature and Electronic Records Consent ("E-SIGN Consent") explains how Hannah Howard Funding ("Hannah Howard Funding," "we," "our," or "us") provides disclosures, agreements, notices, records, and other documents electronically.</p>
        <p>By checking the applicable consent box, electronically signing documents, submitting an application, or otherwise using our Services where electronic consent is requested, you agree to receive electronic records and conduct transactions electronically, to the extent permitted by applicable law.</p>
        <p>This Consent supplements our Terms of Use, Privacy Policy, Funding Agreement, TCPA Consent, and any other agreements between you and Hannah Howard Funding.</p>
      </Sec>

      <Sec n="2" title="Consent to Conduct Business Electronically">
        <p>You agree that Hannah Howard Funding may provide electronically:</p>
        <List items={[
          "disclosures;",
          "agreements;",
          "funding documents;",
          "notices;",
          "acknowledgments;",
          "account communications;",
          "repayment information;",
          "transaction updates;",
          "application decisions;",
          "servicing communications; and",
          "other records relating to the Services.",
        ]}/>
        <p>Electronic delivery satisfies any legal requirement that such information be provided in writing, where permitted by law.</p>
      </Sec>

      <Sec n="3" title="Electronic Signatures">
        <p>You agree that electronic signatures, electronic acknowledgments, digital acceptance, checked consent boxes, typed names, authenticated clicks, or similar electronic methods intended to indicate acceptance may have the same legal effect as handwritten signatures, to the extent permitted by applicable law.</p>
      </Sec>

      <Sec n="4" title="Delivery of Electronic Records">
        <p>Electronic records may be delivered through one or more of the following methods:</p>
        <List items={[
          "email;",
          "secure web portal;",
          "downloadable PDF documents;",
          "electronic signature platform;",
          "secure document links;",
          "SMS notifications directing you to documents;",
          "other secure electronic methods that Hannah Howard Funding may implement.",
        ]}/>
      </Sec>

      <Sec n="5" title="Hardware and Software Requirements">
        <p>To access and retain electronic records, you should have:</p>
        <List items={[
          "a device with internet access;",
          "a current web browser;",
          "a valid email address;",
          "the ability to receive SMS messages if applicable;",
          "software capable of opening PDF documents;",
          "sufficient storage or printing capability to retain records.",
        ]}/>
        <p>You are responsible for maintaining your own hardware, software, internet access, and contact information.</p>
      </Sec>

      <Sec n="6" title="Updating Contact Information">
        <p>You agree to promptly notify Hannah Howard Funding if your:</p>
        <List items={[
          "email address;",
          "telephone number;",
          "mailing address; or",
          "other contact information changes.",
        ]}/>
        <p>Failure to maintain accurate contact information may delay delivery of important communications.</p>
      </Sec>

      <Sec n="7" title="Paper Copies">
        <p>Where permitted by law and operationally available, you may request a paper copy of certain electronic records by contacting Hannah Howard Funding.</p>
        <p>The Company reserves the right to charge a reasonable fee, if permitted by law, for providing paper copies after electronic delivery has occurred.</p>
        <p>Certain records may be available only in electronic form where permitted by applicable law.</p>
      </Sec>

      <Sec n="8" title="Withdrawal of Consent">
        <p>You may request to withdraw your consent to receive electronic records by contacting Hannah Howard Funding.</p>
        <p>Withdrawal of consent may affect our ability to:</p>
        <List items={[
          "process applications;",
          "complete funding transactions;",
          "administer existing agreements;",
          "provide electronic account services.",
        ]}/>
        <p>Withdrawal of consent does not affect the validity of electronic records or signatures created before the withdrawal became effective.</p>
      </Sec>

      <Sec n="9" title="Record Retention">
        <p>You are encouraged to download, print, or otherwise retain copies of all agreements, disclosures, funding documents, and communications for your records.</p>
        <p>Hannah Howard Funding may retain electronic records in accordance with its record retention policies and applicable law.</p>
      </Sec>

      <Sec n="10" title="Security">
        <p>Electronic records may be transmitted or stored using secure third-party providers that assist Hannah Howard Funding in delivering its Services.</p>
        <p>Reasonable administrative, technical, and organizational safeguards are used to protect electronic records; however, no electronic transmission or storage system can be guaranteed to be completely secure.</p>
      </Sec>

      <Sec n="11" title="Severability">
        <p>If any portion of this E-SIGN Consent is determined to be invalid or unenforceable, the remaining provisions shall remain in full force and effect to the maximum extent permitted by applicable law.</p>
      </Sec>

      <Sec n="12" title="Changes to this Consent">
        <p>Hannah Howard Funding may revise this E-SIGN Consent from time to time.</p>
        <p>The Effective Date listed above reflects the most recent revision.</p>
        <p>Continued use of the Services after revised terms become effective constitutes acknowledgment of the updated E-SIGN Consent where permitted by applicable law.</p>
      </Sec>

      <Sec n="13" title="Contact Information">
        <p>Questions regarding this E-SIGN Consent may be directed to:</p>
        <p>
          Hannah Howard Funding<br />
          Email: hello@hannahhowardfunding.com<br />
          Phone: (870) 919-9520<br />
          Mailing Address: 495 Brickell Ave Miami, FL 33131
        </p>
      </Sec>
    </LegalPageLayout>
  );
}
